import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskService } from '../../../../services/task.service';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import { MinorEditsService } from '../../../../services/minor-edits.service';
import { MinorEditsOrderComponent } from '../minor-edits-order/minor-edits-order.component';
import WorkflowStates = Boo.Objects.Enums.WorkflowStates;

@Component({
  selector: 'app-components-shared-onsite-task-information',
  templateUrl: './onsite-task-information.component.html',
  styleUrls: ['../customer-campaign/customer-campaign.component.scss']
})
export class OnsiteTaskInformationComponent implements OnInit {

  @Input() websiteUrl: Boo.Objects.WebsiteUrl;
  @Input() customerId: number;
  @Input() restrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[];
  @Input() reviewSource: Boo.OnsiteRecommendations.Models.Enums.ReviewSources;

  websiteUrlTask: Boo.Objects.WebsiteUrlTask;
  taskActionPending = false;
  taskTypeLabel: string
  allowVerification: boolean;
  allowApproveReject: boolean;
  hasOpenMinorEditsWorkflow = true;
  allowMinorEdits: boolean;

  customerCampaignRestrictionTypes_DisableTaskActions = Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.DisableTaskActions;

  private unverifiedTaskTypes: Boo.Objects.Enums.TaskTypeEnum[] = [
    Boo.Objects.Enums.TaskTypeEnum.PageCreationCreateContent,
    Boo.Objects.Enums.TaskTypeEnum.PageCreationRewriteContent,
    Boo.Objects.Enums.TaskTypeEnum.PageOptimizationCreateContent,
    Boo.Objects.Enums.TaskTypeEnum.PageOptimizationRewriteContent
  ];

  constructor(
    private modalService: NgbModal,
    private customerCampaignService: CustomerCampaignService,
    private taskService: TaskService,
    private minorEditsService: MinorEditsService
  ) { }

  ngOnInit(): void {
    this.websiteUrlTask = this.websiteUrl.WebsiteUrlTask;
    this.taskTypeLabel = this.customerCampaignService.getTaskTypeLabelMap()[this.websiteUrlTask.TaskTypeId];
    this.calculateButtonDisplay();
    this.minorEditsService.hasOpenWorkflow(this.customerId, this.websiteUrlTask.WebsiteUrlId)
      .subscribe(hasOpen => this.hasOpenMinorEditsWorkflow = hasOpen);
  }

  reloadTask(taskId: number): void {
    this.customerCampaignService.getTaskInfo(this.customerId, taskId).subscribe(task => {
      this.websiteUrlTask.TaskStatusId = task.TaskStatusId;
      this.websiteUrlTask.WorkflowState = task.WorkflowState;
      this.websiteUrlTask.WorkflowStateId = task.WorkflowStateId;
      this.websiteUrlTask.TaskCompletedDate = task.TaskCompletedDate;
      this.websiteUrlTask.TaskPublishedDate = task.TaskPublishedDate;
      this.websiteUrlTask.TaskVerifiedDate = task.TaskVerifiedDate;
      this.websiteUrlTask.TaskActionUrl = task.TaskActionUrl;
      this.websiteUrlTask.HavePriorTasksBeenRejected = task.HavePriorTasksBeenRejected;
      this.websiteUrlTask.DisplayStatus = task.DisplayStatus;
      this.websiteUrlTask.DisplayStatusId = task.DisplayStatusId;

      this.customerCampaignService.calculateReadOnlyState(this.websiteUrl);
      this.calculateButtonDisplay();
      this.taskActionPending = false;
    });
  }

  calculateButtonDisplay(): void {
    this.allowVerification = (this.websiteUrlTask.TaskPublishedDate != null || this.websiteUrlTask.WorkflowStateId == Boo.Objects.Enums.WorkflowStates.Completed)
      && this.websiteUrlTask.TaskVerifiedDate == null
      && !this.unverifiedTaskTypes.includes(this.websiteUrlTask.TaskTypeId);
    this.allowApproveReject = this.websiteUrlTask.WorkflowStateId == Boo.Objects.Enums.WorkflowStates.ReadyForCsrApproval
      && this.websiteUrlTask.TaskStatusId != Boo.Objects.Enums.TaskStatusEnum.ReconcileComplete;
    this.allowMinorEdits = [WorkflowStates.Completed, WorkflowStates.Deleted, WorkflowStates.ReconcileCompleted, WorkflowStates.Canceled].includes(this.websiteUrlTask.WorkflowStateId);
  }

  openMinorEditsModal(): void {
    const modalRef = this.modalService.open(MinorEditsOrderComponent, { size: 'lg' });
    modalRef.componentInstance.customerId = this.customerId;
    modalRef.componentInstance.websiteUrlId = this.websiteUrlTask.WebsiteUrlId;
    modalRef.closed.subscribe(() => {
      this.hasOpenMinorEditsWorkflow = true;
    });
  }

  setTaskActionPending(pending: boolean): void {
    this.taskActionPending = pending;
  }

  verifyTask(): void {
    this.taskActionPending = true;
    this.taskService.verify(this.websiteUrlTask.TaskId).subscribe((result: Boo.Objects.VerificationResult) => {
      if (!result.IsVerified) {
        toastr.error(result.Reason);
      } else {
        toastr.success(result.Reason);
        this.reloadTask(this.websiteUrlTask.TaskId);
      }
      this.taskActionPending = false;
    })
  }
}
